import React, { useEffect, useState } from "react";
import { addProject, getProjectById, getProjects, updateProject } from "../../api/ProjectApi";
import { useParams, useNavigate } from "react-router-dom";
import ProjectForm from "./ProjectForm";
import { getCompanies } from "../../api/CompanyApi";
import { Form } from "antd";
import moment from "moment";
import AdnMessageSuccess from "../common/adnMessage/AdnMessageSuccess";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { addProjectTehcnology, getProjectTechnologies, deleteProjectTechnology } from "../../api/ProjectTechnologyApi";
import { getTechnologies } from "../../api/TechnologyApi";
import { deleteTeamMember, getTeamMembers } from "../../api/TeamMemberApi";
import { AppRoutes } from "../../AppRoutes";

const ManageProjectPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [technologyForm] = Form.useForm();
    const [teamMemberForm] = Form.useForm();
    const [companyData, setCompanyData] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const [visible, setVisible] = useState(false);
    const [visibleTeamMembers, setVisibleTeamMembers] = useState(false);
    const [visibleProjectTechnologies, setVisibleProjectTechnologies] = useState(false);
    const [event, setEvent] = useState("");
    const [eventProjectTechnology, setEventProjectTechnology] = useState("");
    const [searchTechnology, setSearchTechnology] = useState("");
    const [searchOptions, setSearchOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [projectTechnologyData, setProjectTechnologyData] = useState([]);
    const [projectTeamMemberData, setProjectTeamMemberData] = useState([]);
    const [projectName, setProjectName] = useState("");
    useEffect(() => {
        getCompanyData();
        if (id) {
            getProjectByIdData();
            allProjectTechnologies();
            allProjectTeamMembers();
            setEvent("edit");
            setVisibleTeamMembers(true);
            setVisibleProjectTechnologies(true);
        } else {
            setEvent("add");
            setVisibleTeamMembers(false);
            setVisibleProjectTechnologies(false);
        }
    }, []);

    useEffect( () => {
         allProjectTechnologies();
         technologyOptions();
    }, [searchTechnology]);

    const getProjectData = () => {
        getProjects().then((res) => {
            if (res.status == 200 && res.data.result) {
                setProjectData(res.data.result);
                setLoading(false);
                navigate(-1)
            } else {
                AdnMessageError();
                setLoading(false);
            }
        });
    };

    const submitProject = (values) => {
        values.companyName = console.log(values);
        if (event === "add") {
            setLoading(true);
            addProject(values).then((res) => {
                if (res.status === 201 && res.data.success === true) {
                    setVisible(false);
                    getProjectData();
                    AdnMessageSuccess();
                } else {
                    AdnMessageError();
                }
            });
        } else if (event === "edit") {
            values.id = id;
            setLoading(true);
            updateProject(values).then((res) => {
                if (res.status === 200 && res.data.success === true) {
                    setVisible(false);
                    getProjectData();
                    AdnMessageSuccess();
                } else {
                    AdnMessageError();
                }
            });
        }
        setLoading(false);
    };


    const submitProjectTechnology = (values) => {
        addProjectTehcnology(values).then((res) => {
            if (res.status === 201) {
                AdnMessageSuccess();
                addProjectTehcnology();
                setVisible(false);
                allProjectTechnologies();
            } else {
                AdnMessageError();
                allProjectTechnologies();
            }
        });
    };

    const getProjectByIdData = () => {
        getProjectById(id).then((res) => {
            if (res.status === 200) {
                res.data.publishDate = moment(res.data.publishDate);
                res.data.endDate = moment(res.data.endDate);
                if (res.data.questionEndDate !== null) {
                    res.data.questionEndDate = moment(res.data.questionEndDate);
                }

                form.setFieldsValue(res.data);
                setProjectName(res.data.name);
            } else {
                navigate(AppRoutes.home.path);
            }
        });
    };

    const getCompanyData = () => {
        getCompanies().then((res) => {
            if (res.status === 200) {
                setCompanyData(res.data);
            }
        });
    };

    const handleSearchTecnology = (value) => {
        if (value.length >= 1) {
            setSearchTechnology(value);
        } else setSearchTechnology("");
    };

    const handleSelectTecnology = (value) => {
        setSearchTechnology(value);
        technologyForm.setFieldsValue(value);
    };

    const handleDeleteTecnology = async (id) => {
        await deleteProjectTechnology(id).then((res) => {
            if (res.status === 200) {
                AdnMessageSuccess();
                allProjectTechnologies();
            } else {
                AdnMessageError();
                allProjectTechnologies();
            }
        });
    };

    const handleDeleteTeamMember = async (id) => {
        await deleteTeamMember(id).then((res) => {
            if (res.status === 200) {
                AdnMessageSuccess();
                allProjectTeamMembers();
            } else {
                AdnMessageError();
                allProjectTeamMembers();
            }
        });
    };

    const handleProjectTechnologySubmit = () => {
        let projectTechnology = {
            projectId: parseInt(id),
            technologyId: searchOptions.find((x) => x.name === searchTechnology)?.id,
        };

        if (searchTechnology !== "") submitProjectTechnology(projectTechnology);
    };

    const technologyOptions = async () => {
        let filteredTechnologyOptions = [];
        await getTechnologies(searchTechnology).then((res) => {
            filteredTechnologyOptions = res.data.result.filter(function (
                element
            ) {
                projectTechnologyData.forEach((e) => {
                    if (element.name === e.technologyName) {
                        return false;
                    }
                });
                return true;
            })
        })

        setSearchOptions(filteredTechnologyOptions);
    };

    const allProjectTechnologies = async () => {
        await getProjectTechnologies(id).then((res) => {
            setProjectTechnologyData(res.data.result);
        });
    };

    const disabledPublishDate = (current) => {
        return current.year() > moment().year();
    };

    const disabledEndDate = (current) => {
        let publishDate = form.getFieldValue("publishDate");
        let questionEndDate = form.getFieldValue("questionEndDate");

        return questionEndDate ? current.startOf('day') <= questionEndDate.startOf('day') :
            current.startOf('day') <= publishDate?.startOf('day')
    };

    const disabledQuestionEndDate = (current) => {
        let publishDate = form.getFieldValue("publishDate");
        let endDate = form.getFieldValue("endDate");

        return publishDate || endDate ? current.startOf('day') <= publishDate?.startOf('day') ||
            current.startOf('day') >= endDate?.startOf('day') : null
    };

    const allProjectTeamMembers = async () => {
        await getTeamMembers("", id).then((res) => {
            setProjectTeamMemberData(res.data.result);
        });
    };

    const handleCancel = () => {
        navigate(AppRoutes.projectList.path);
    };
    const addTeamMember = () => {
        navigate();
    };

    return (
        <ProjectForm
            event={event}
            companyData={companyData}
            form={form}
            technologyForm={technologyForm}
            teamMemberForm={teamMemberForm}
            setEvent={setEvent}
            setVisible={setVisible}
            visible={visible}
            handleSearchTecnology={handleSearchTecnology}
            handleSelectTecnology={handleSelectTecnology}
            handleCancel={handleCancel}
            submitProjectTechnology={submitProjectTechnology}
            searchOptions={searchOptions}
            onFinish={submitProject}
            loading={loading}
            handleProjectTechnologySubmit={handleProjectTechnologySubmit}
            setEventProjectTechnology={eventProjectTechnology}
            projectTechnologyData={projectTechnologyData}
            projectTeamMemberData={projectTeamMemberData}
            handleDeleteTecnology={handleDeleteTecnology}
            handleDeleteTeamMember={handleDeleteTeamMember}
            setVisibleTeamMembers={setVisibleTeamMembers}
            visibleTeamMembers={visibleTeamMembers}
            addTeamMember={addTeamMember}
            technologyOptions={technologyOptions}
            disabledPublishDate={disabledPublishDate}
            disabledEndDate={disabledEndDate}
            disabledQuestionEndDate={disabledQuestionEndDate}
        />
    );
};

export default ManageProjectPage;
